import { render } from "./IconPoint.vue?vue&type=template&id=e32a7f94&scoped=true&ts=true"
import script from "./IconPoint.vue?vue&type=script&lang=ts"
export * from "./IconPoint.vue?vue&type=script&lang=ts"

import "./IconPoint.vue?vue&type=style&index=0&id=e32a7f94&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e32a7f94"]])

export default __exports__